import { useOnlineStatus } from '../hooks/useOnlineStatus';
import { WifiOff, Wifi } from 'lucide-react';
import { useEffect, useState } from 'react';

export default function OfflineIndicator() {
  const isOnline = useOnlineStatus();
  const [showNotification, setShowNotification] = useState(false);
  const [message, setMessage] = useState('');

  useEffect(() => {
    if (!isOnline) {
      setMessage('You are offline. Viewing cached data.');
      setShowNotification(true);
    } else {
      setMessage('Back online');
      setShowNotification(true);
      
      // Hide "back online" message after 3 seconds
      const timer = setTimeout(() => {
        setShowNotification(false);
      }, 3000);

      return () => clearTimeout(timer);
    }
  }, [isOnline]);

  // Always show indicator when offline
  if (!isOnline) {
    return (
      <div className="fixed top-0 left-0 right-0 z-50 bg-amber-500 text-white">
        <div className="container mx-auto px-4 py-2 flex items-center justify-center gap-2 text-sm">
          <WifiOff className="w-4 h-4" />
          <span className="font-medium">{message}</span>
        </div>
      </div>
    );
  }

  // Show "back online" notification temporarily
  if (showNotification && isOnline) {
    return (
      <div className="fixed top-0 left-0 right-0 z-50 bg-green-500 text-white animate-in slide-in-from-top">
        <div className="container mx-auto px-4 py-2 flex items-center justify-center gap-2 text-sm">
          <Wifi className="w-4 h-4" />
          <span className="font-medium">{message}</span>
        </div>
      </div>
    );
  }

  return null;
}
